import { render, staticRenderFns } from "./PromoCardsPage.vue?vue&type=template&id=4280baf6&scoped=true&"
import script from "./PromoCardsPage.vue?vue&type=script&lang=ts&"
export * from "./PromoCardsPage.vue?vue&type=script&lang=ts&"
import style0 from "./PromoCardsPage.vue?vue&type=style&index=0&id=4280baf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4280baf6",
  null
  
)

export default component.exports